import get from 'lodash/get'
import type { RootState } from '@/redux/interfaces'
import type { IDataState, IFetchDataPayload, INamedDataState, TApiUrlName } from './interfaces'
import { responseMapper } from './responseMapper'

export const hasParamInUrl =
  (paramName: string) =>
  ({ params }: Partial<IFetchDataPayload>): boolean =>
    Boolean(params?.[paramName])

export const getDataByName =
  <T>(name: TApiUrlName) =>
  (state: IDataState): INamedDataState<T> =>
    get(state, `loadedData.${name}`)

export const setDataByName = (name: TApiUrlName, payload: INamedDataState) => (state: IDataState) => {
  state.loadedData[name] = { ...getDataByName(name), ...payload }
}
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTransformedResponse = (name: TApiUrlName, data: any) => (state: RootState) => {
  const mapResponse = responseMapper[name]
  if (mapResponse) data = mapResponse(data, state)

  return data
}
